import React from 'react';
import classnames from 'classnames';
import AutoTextarea from '@gp/components/AutoTextarea';
import { ActionItemStatusTag } from '@gp/components/StatusTag';

import type { IBaseProps } from '@home/types/common';
import type { IGRActionItemVO } from '@gp/types/projectUpdate';

import './index.scss';

interface IActionItemsContentsProps extends IBaseProps {
  // 是否为GR Action Items，默认为false
  isGRActionItems?: boolean;
  data?: IGRActionItemVO[] | null;
}

const ActionItemsContents: React.FC<IActionItemsContentsProps> = (props) => {
  const { style, className, isGRActionItems = false, data: actionItems } = props;
  return (
    <div style={style} className={classnames('dbg-action-items-list', className)}>
      {actionItems?.map((actionItem, actionItemIndex) => {
        const {
          status,
          due_date: dueDate,
          user_name: userName,
          comment,
          status_comment: statusComment,
          category,
        } = actionItem || {};
        return (
          <div key={actionItemIndex} className="dbg-action-items-item">
            <div className="dbg-action-items-item__header">
              <span className="dbg-milestone-gr-item-category">{category?.trim() || '-'}</span>{' '}
              <span className="dbg-action-items-item__header-title">DUE {dueDate || '-'}</span>
              {/* 分割线 */}
              <span className="dbg-vertical-divider"></span>
              <span className="dbg-action-items-item__header-sub-title">{userName || '-'}</span>
            </div>
            <div className="dbg-action-items-item__body">
              <AutoTextarea readOnly defaultValue={comment || '-'} />
            </div>
            <div className="dbg-action-items-item__footer">
              <div className="dbg-action-items-item__footer-icon-text">
                <ActionItemStatusTag status={status} />
                {isGRActionItems && (
                  // 分割线
                  <span className="dbg-vertical-divider"></span>
                )}
              </div>
              {isGRActionItems && (statusComment || '-')}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default React.memo(ActionItemsContents);
